import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LinkButton from '../../_atomic/LinkButton/LinkButton';
import mask from '../CurrencyField/assets/mask';
import './UserBalance.scss';
import InfoModal from '../InfoModal/InfoModal';
import Button from '../../_atomic/Button/Button';


class UserBalance extends Component {
  static propTypes = {
    amount: PropTypes.number.isRequired,
    isAdmin: PropTypes.bool,
  };

  static defaultProps = {
    isAdmin: false,
  }
  state = {
    showInfoModal: false,
  }
  showModal = () => {
    this.setState(() => ({
      showInfoModal: true,
    }));
  }
  hideModal = () => {
    this.setState(() => ({
      showInfoModal: false,
    }));
  }
  renderModalFooter = () => (
    <div className="button-wrapper">
      <Button label="OK" clickHandler={this.hideModal} />
    </div>
  )
  render() {
    const { amount, isAdmin } = this.props;
    const { showInfoModal } = this.state;
    return (
      <div className="user-balance-wrapper">
        {!isAdmin &&
        <InfoModal id="refound-modal" footer={this.renderModalFooter()} visible={showInfoModal} >
          <div className="modal-body">
            <div className="modal-header">
              <span>To get a refund please contact the support at <br /> <a href="mailto:support@advaice.com"> support@advaice.com </a></span>
            </div>
          </div>
        </InfoModal>}
        <div className="middle-text"><span>Balance</span></div>
        <div className="row">
          <div className="balance-amount">
            <span>{mask(amount)}</span> <span className="currency-sign">$</span>
          </div>
          {!isAdmin &&
          <div className="refund-link"><LinkButton text="Refund" clickHandler={this.showModal} /> </div>
          }
        </div>
      </div>
    );
  }
}

export default UserBalance;



// WEBPACK FOOTER //
// ./src/components/_molecules/UserBalance/UserBalance.js